import PropTypes from 'prop-types';
import React from 'react';

import VScroll from '../../../../gd-components/scrolling/custom-v-scroll/v-scroll.tsx';
import Button from 'gd-comp-button';
import FileItem from './file-item.jsx';
import AddFolder from './add-folder.jsx';
import PathView from './path-view.jsx';

import _ from 'lodash';

class ModalGoogleDriveViewRoot extends React.Component {
    static propTypes = {
        data: PropTypes.array,

        onFolderClick: PropTypes.func,
        onAddFolder: PropTypes.func,
        onSelectRoot: PropTypes.func,
        onRefresh: PropTypes.func,
    };

    static defaultProps = {
        data: []
    };

    state = {
        data: this.props.data,
        parents: [{
            id: null,
            name: "Google drive"
        }],
        addFolderState: false
    };

    UNSAFE_componentWillReceiveProps(nextProps) {
        this.setState({data: nextProps.data});
    }

    onSelectRoot = () => {
        const { onSelectRoot } = this.props;
        const { parents } = this.state;
        if (onSelectRoot) onSelectRoot(parents[parents.length-1]);
        gd.modal.hide();
    };

    onFolderClick = (folderId, folderName) => {
        const { onFolderClick } = this.props;
        const { parents } = this.state;

        const newParents = parents.slice();
        newParents.push({
            id: folderId,
            name: folderName
        });

        this.setState({
            parents: newParents,
            data: null,
            checkedFiles: []
        }, ()=>{if (onFolderClick) onFolderClick(folderId)});
    };

    onParentFolderClick = () => {
        const { onFolderClick } = this.props;
        const { parents } = this.state;

        const newParents = parents.slice();
        newParents.pop();
        const parentFolderId = newParents[newParents.length-1].id;
        this.setState({
            parents: newParents,
            data: null,
            checkedFiles: []
        }, ()=>{if (onFolderClick) onFolderClick(parentFolderId)});
    };

    onParentClick = (id) => {
        const { onFolderClick } = this.props;
        const { parents } = this.state;

        const newParents = parents.slice(0,_.findIndex(parents, p=>p.id === id) + 1);
        this.setState({
            parents: newParents,
            data: null,
            checkedFiles: []
        }, ()=>{if (onFolderClick) onFolderClick(id)});
    };

    onDeleteClick = (id) => {
        const { onDeleteClick } = this.props;
        if (onDeleteClick) onDeleteClick(id);
    };

    onRefresh = () => {
        const { onRefresh } = this.props;
        if (onRefresh) onRefresh();
    };

    onNewFolder = () => {
        this.setState({addFolderState: true});
    };

    onCancelAddFolder = () => {
        this.setState({addFolderState: false});
    };

    onAddFolder = (result) => {
        const { onAddFolder } = this.props;
        this.setState({addFolderState: false},
            ()=>{if (onAddFolder) onAddFolder(result.title)});
    };

    renderMain = () => {
        const { data, parents, addFolderState } = this.state;

        const listItems = [];
        if (data) {
            const sortedData = _.chain(data)
                .filter(i=>i.mimeType.indexOf("folder") !== -1)
                .orderBy(['name'],['asc'])
                .value();

            sortedData.map((d,key)=>{
                listItems.push(<FileItem key={d.id ? d.id : "temp_"+key}
                                         id={d.id}
                                         mimeType={d.mimeType}
                                         iconLink={d.iconLink}
                                         name={d.name}
                                         onFolderClick={this.onFolderClick}
                                         onDeleteClick={this.onDeleteClick}/>)
            })
        }

        let main;
        if (addFolderState) {
            main = <AddFolder onAddFolder={this.onAddFolder} onCancel={this.onCancelAddFolder}/>;
        } else {
            main = (
                <div className="main-body">
                    <VScroll className="main-list">
                        {parents.length > 1 &&
                        <div className="up-button" onClick={this.onParentFolderClick}>
                            <div className="icon i5-long-arrow-up"> </div>
                            Parent folder
                        </div>}

                        {listItems}
                    </VScroll>
                </div>
            );
        }
        return main;
    };

    render() {
        const { parents, addFolderState } = this.state;

        return (
            <div className="main-content">
                <div className="main-title"><img className="gdrive-icon" src="/app/web/skin/common/svg/g-drive.svg"/>Google Drive. Choose root folder</div>
                <div className="main-header">
                    <PathView parents={parents} onParentClick={this.onParentClick}/>

                    <div className="actions root-view">
                        <div className="action-button new-button" onClick={this.onNewFolder}><div className="icon i5-plus"> </div>New folder</div>
                        <div className="action-button refresh-button" onClick={this.onRefresh}><div className="icon i5-refresh"> </div>Refresh</div>
                    </div>
                </div>

                {this.renderMain()}

                <div className="main-actions">
                    {!addFolderState && <Button onClick={this.onSelectRoot} label="Set current as root" type="primary"/>}
                </div>
            </div>
        );
    }
}

module.exports = ModalGoogleDriveViewRoot;